import type { RuleAttachment } from "./api";

export const RULE_MAX_ATTACHMENTS = 3;

/** PDFs propios del reglamento: lista nueva o, en filas legacy, el único
 * original_pdf_url. */
export function ruleAttachments(rule: { attachments?: RuleAttachment[] | null; original_pdf_url?: string | null; original_pdf_filename?: string | null } | null | undefined): RuleAttachment[] {
  if (!rule) return [];
  if (rule.attachments && rule.attachments.length > 0) return rule.attachments;
  if (rule.original_pdf_url) return [{ url: rule.original_pdf_url, filename: rule.original_pdf_filename ?? null }];
  return [];
}

/** Nombre legible de un archivo subido a partir de su URL (última parte,
 * sin el prefijo uuid que agrega el servidor). */
export function uploadedFileName(url: string | null | undefined): string | null {
  if (!url) return null;
  const last = url.split("?")[0].split("/").pop() ?? "";
  if (!last) return null;
  return decodeURIComponent(last.replace(/^[0-9a-f]{32}-/i, ""));
}
